<template v-cloak>
    <article class="search-results-item">
        <a class="search-results-item__link" v-if="link" :href="link">
            <h3 class="search-results-item__title" v-if="title" v-html="title"></h3>
            <div class="search-results-item__excerpt" v-if="excerpt" v-html="excerpt" />
            <div class="search-results-item__breadcrumbs" v-if="breadcrumbs" v-html="breadcrumbs"></div>
        </a>
    </article>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: false,
            default: null
        },
        excerpt: {
            type: String,
            required: false,
            default: null
        },
        link: {
            type: String,
            required: true
        }
    },
    computed: {
        breadcrumbs() {
            let breadcrumbs = this.link.replace(/(^\w+:|^)\/\//, "").split("/");
            breadcrumbs.shift();
            breadcrumbs.unshift("Home");
            const index = breadcrumbs.findIndex(element => element === "");
            if (index) {
                breadcrumbs.splice(index, 1);
            }
            breadcrumbs.pop();
            breadcrumbs.push(this.title);
            return breadcrumbs.join(" > ");
        }
    }
};
</script>
